<template>
    <div>
        <span>
            {{
                props.formattedRow[props.column.field].length > 20
                ? props.formattedRow[props.column.field].substring(0, 20) + '...'
                : props.formattedRow[props.column.field]
            }}
        </span> 
    </div>
</template>
<script>
    export default ({
        name: 'datatable-row-default',
        props: {
            props: Object,
        },
        data() {
            return {
        }},
        mounted() {
        },
        methods: {}
    })
    </script>